export default {
  submitted: false,
  created: null,
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js